import React from 'react';

import styles from './SectionTitleBlock.module.scss';

interface Props {
  title: string;
}

export const SectionTitleBlock: React.FC<Props> = (props) => {
  return (
    <div className={styles.container}>
      <span className={styles.title}>{props.title.toUpperCase()}</span>
    </div>
  );
};
